import { TableColumn } from '../components';

export const DISTRIBUTION_NETWORK_TABLE_DEFAULT_COLUMNS: TableColumn[] = [
  {
    key: 'transformer',
    columnKey: 'transformer',
    title: 'DISTRIBUTION_NETWORK.TABLE.COLUMN_TRANSFORMER',
    align: 'left',
    sort: true,
    width: '200px',
  },
  {
    key: 'center',
    columnKey: 'center',
    title: 'DISTRIBUTION_NETWORK.TABLE.COLUMN_CENTER',
    align: 'left',
    sort: false,
    width: '100px',
  },
  {
    key: 'outputBt',
    columnKey: 'outputBt',
    title: 'DISTRIBUTION_NETWORK.TABLE.COLUMN_OUTPUTBT',
    align: 'left',
    sort: false,
    width: '100px',
  },
  {
    key: 'intensity',
    columnKey: 'percentageIntensity',
    title: 'DISTRIBUTION_NETWORK.TABLE.COLUMN_INTENSITY',
    align: 'right',
    sort: true,
    width: '100px',
  },
  {
    key: 'power',
    columnKey: 'percentagePower',
    title: 'DISTRIBUTION_NETWORK.TABLE.COLUMN_POWER',
    align: 'right',
    sort: true,
    width: '100px',
  },
  {
    key: 'waveQuality',
    columnKey: 'waveStatus',
    title: 'DISTRIBUTION_NETWORK.TABLE.COLUMN_WAVEQUALITY',
    align: 'center',
    sort: true,
    width: '100px',
  },
  {
    key: 'temperature',
    columnKey: 'temperature',
    title: 'DISTRIBUTION_NETWORK.TABLE.COLUMN_TEMPERATURE',
    align: 'right',
    sort: true,
    width: '100px',
  },
  {
    key: 'statusUpdate',
    columnKey: 'updatedAt',
    title: 'DISTRIBUTION_NETWORK.TABLE.COLUMN_STATUSUPDATE',
    align: 'center',
    sort: true,
    width: '150px',
  },
  {
    key: 'actions',
    columnKey: 'actions',
    title: 'DISTRIBUTION_NETWORK.TABLE.COLUMN_ACTIONS',
    align: 'center',
    sort: false,
    width: '50px',
  },
];

export const RANKING_LINES_INTENSITY_TABLE_DEFAULT_COLUMNS: TableColumn[] = [
  {
    key: 'line',
    columnKey: 'line',
    title: 'CHARTS.PHASE_INTENSITY.COLUMN_1',
    align: 'left',
    sort: false,
    width: '',
  },
  {
    key: 'maxIntensity',
    columnKey: 'maxIntensity',
    title: 'CHARTS.PHASE_INTENSITY.COLUMN_2',
    align: 'right',
    sort: false,
    width: '150px',
  },
  {
    key: 'intensityPhase',
    columnKey: 'intensityPhase',
    title: 'CHARTS.PHASE_INTENSITY.COLUMN_3',
    align: 'left',
    sort: false,
    width: '150px',
  },
];

export const RANKING_RSABTS_RSABT_MAX_INTENSITY_DEFAULT_COLUMNS: TableColumn[] =
  [
    {
      key: 'rsabt',
      columnKey: 'rsabt',
      title: 'RSABT_MAX_INTENSITY.COLUMN_1',
      align: 'left',
      sort: false,
      width: '',
    },
    {
      key: 'center',
      columnKey: 'center',
      title: 'RSABT_MAX_INTENSITY.COLUMN_2',
      align: 'left',
      sort: false,
      width: '180px',
    },
    {
      key: 'maxIntensity',
      columnKey: 'maxIntensity',
      title: 'RSABT_MAX_INTENSITY.COLUMN_3',
      align: 'right',
      sort: false,
      width: '100px',
    },
    {
      key: 'intensityPhase',
      columnKey: 'intensityPhase',
      title: 'RSABT_MAX_INTENSITY.COLUMN_4',
      align: 'left',
      sort: false,
      width: '90px',
    },
    {
      key: 'timestamp',
      columnKey: 'timestamp',
      title: 'RSABT_MAX_INTENSITY.COLUMN_5',
      align: 'left',
      sort: false,
      width: '50px',
    },
  ];

export const RANKING_TSABTS_RSABT_MAX_INTENSITY_DEFAULT_COLUMNS: TableColumn[] =
  [
    {
      key: 'tsabt',
      columnKey: 'tsabt',
      title: 'TSABT_MAX_INTENSITY.COLUMN_1',
      align: 'left',
      sort: false,
      width: '',
    },
    {
      key: 'maxIntensity',
      columnKey: 'maxIntensity',
      title: 'TSABT_MAX_INTENSITY.COLUMN_2',
      align: 'right',
      sort: false,
      width: '100px',
    },
    {
      key: 'intensityPhase',
      columnKey: 'intensityPhase',
      title: 'TSABT_MAX_INTENSITY.COLUMN_3',
      align: 'center',
      sort: false,
      width: '70px',
    },
    {
      key: 'timestamp',
      columnKey: 'timestamp',
      title: 'TSABT_MAX_INTENSITY.COLUMN_4',
      align: 'left',
      sort: false,
      width: '70px',
    },
  ];

export const ALARMS_TABLE_DEFAULT_COLUMNS: TableColumn[] = [
  {
    key: 'center',
    columnKey: 'center',
    title: 'ALARMS.TABLE.COLUMN_1',
    align: 'left',
    sort: false,
    width: '200px',
  },
  {
    key: 'line',
    columnKey: 'line',
    title: 'ALARMS.TABLE.COLUMN_9',
    align: 'left',
    sort: false,
    width: '200px',
  },
  {
    key: 'category',
    columnKey: 'category',
    title: 'ALARMS.TABLE.COLUMN_2',
    align: 'left',
    sort: false,
    width: '150px',
  },
  {
    key: 'priority',
    columnKey: 'priority',
    title: 'ALARMS.TABLE.COLUMN_3',
    align: 'center',
    sort: false,
    width: '60px',
  },
  {
    key: 'phase',
    columnKey: 'phase',
    title: 'ALARMS.TABLE.COLUMN_4',
    align: 'center',
    sort: false,
    width: '50px',
  },
  {
    key: 'field',
    columnKey: 'field',
    title: 'ALARMS.TABLE.COLUMN_5',
    align: 'center',
    sort: false,
    width: '80px',
  },
  {
    key: 'start',
    columnKey: 'start',
    title: 'ALARMS.TABLE.COLUMN_6',
    align: 'right',
    sort: false,
    width: '60px',
  },
  {
    key: 'duration',
    columnKey: 'duration',
    title: 'ALARMS.TABLE.COLUMN_7',
    align: 'right',
    sort: false,
    width: '60px',
  },
  {
    key: 'actions',
    columnKey: 'actions',
    title: 'ALARMS.TABLE.COLUMN_8',
    align: 'right',
    sort: false,
    width: '50px',
  },
];

export const EVENTS_TABLE_DEFAULT_COLUMNS: TableColumn[] = [
  {
    key: 'center',
    columnKey: 'center',
    title: 'EVENTS.TABLE.COLUMN_1',
    align: 'left',
    sort: false,
    width: '200px',
  },
  {
    key: 'category',
    columnKey: 'category',
    title: 'EVENTS.TABLE.COLUMN_2',
    align: 'left',
    sort: false,
    width: '150px',
  },
  {
    key: 'date',
    columnKey: 'date',
    title: 'EVENTS.TABLE.COLUMN_3',
    align: 'right',
    sort: false,
    width: '60px',
  },
  {
    key: 'actions',
    columnKey: 'actions',
    title: 'EVENTS.TABLE.COLUMN_4',
    align: 'right',
    sort: false,
    width: '50px',
  },
];

export const LOSSES_TABLE_DEFAULT_COLUMNS: TableColumn[] = [
  {
    key: 'center',
    columnKey: 'center',
    title: 'LOSSES.TABLE.COLUMN_1',
    align: 'left',
    sort: true,
    width: '200px',
  },
  {
    key: 'hoursPercentage',
    columnKey: 'hoursPercentage',
    title: 'LOSSES.TABLE.COLUMN_2',
    align: 'right',
    sort: true,
    width: '100px',
  },
  {
    key: 'losses',
    columnKey: 'losses',
    title: 'LOSSES.TABLE.COLUMN_3',
    align: 'right',
    sort: true,
    width: '210px',
  },
  {
    key: 'energyCT',
    columnKey: 'energyCT',
    title: 'LOSSES.TABLE.COLUMN_4',
    align: 'right',
    sort: true,
    width: '140px',
  },
  {
    key: 'consumption',
    columnKey: 'consumption',
    title: 'LOSSES.TABLE.COLUMN_5',
    align: 'right',
    sort: true,
    width: '140px',
  },
];

export const ADMIN_TABLE_DEFAULT_COLUMNS: TableColumn[] = [
  {
    key: 'center',
    columnKey: 'center',
    title: 'ADMIN.TABLE.COLUMN_1',
    align: 'left',
    sort: false,
    width: '120px',
  },
  {
    key: 'transformer',
    columnKey: 'transformer',
    title: 'ADMIN.TABLE.COLUMN_2',
    align: 'left',
    sort: false,
    width: '120px',
  },
  {
    key: 'line',
    columnKey: 'line',
    title: 'ADMIN.TABLE.COLUMN_3',
    align: 'left',
    sort: false,
    width: '120px',
  },
  {
    key: 'customization',
    columnKey: 'customization',
    title: 'ADMIN.TABLE.COLUMN_4',
    align: 'right',
    sort: false,
    width: '60px',
  },
  {
    key: 'actions',
    columnKey: 'actions',
    title: 'ADMIN.TABLE.COLUMN_5',
    align: 'right',
    sort: false,
    width: '50px',
  },
];
